export let ScimConnectionSource;
(function (ScimConnectionSource) {
  ScimConnectionSource["FRONTEGG"] = "frontegg";
  ScimConnectionSource["OKTA"] = "okta";
  ScimConnectionSource["AZURE_AD"] = "azure-ad";
  ScimConnectionSource["OTHER"] = "other";
})(ScimConnectionSource || (ScimConnectionSource = {}));